//
//
//
//

import LoginForm from '../components/forms/LoginForm';

export default {
	auth: false,
	name: 'Login',
	components: {
		LoginForm,
	},
	head() {
		return {
			title: 'Acceder | La Reverde',
		};
	},
	mounted() {
		const activation = this.$router.currentRoute.query.activation;
		if (activation) {
			this.$store.commit('setAlert', {
				show: true,
				message:
					'¡Enhorabuena! Tu cuenta ya está activada, puedes acceder con tu email y contraseña',
				type: 'success',
			});
		}
	},
};
